import { schemaDocumentSnapshotQueryOptions } from '@valian/react-kitchen-sink'

import { collections } from '@/schema'

export const userQuery = (uid: string | undefined | null) =>
  schemaDocumentSnapshotQueryOptions({
    queryKey: ['users', uid],
    factory: collections.users,
    id: uid,
  })
